import { Component, Inject, OnDestroy } from '@angular/core';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from '@angular/material/dialog';
import { Booking } from '../../models/booking';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  ReactiveFormsModule
} from '@angular/forms';
import { Subject } from 'rxjs';
import { ConfigService } from '../../shared/services/config.service';
import { Router, RouterLink } from '@angular/router';
import { BookingService } from '../../shared/services/booking.service';
import { currencyStringToNumber } from '../../shared/helpers/currencyStringToNumber';
import { MatButton } from '@angular/material/button';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatError } from '@angular/material/form-field';
import { NgIf } from '@angular/common';
import { FlexModule } from '@angular/flex-layout';
import { BookingItemNamePipe } from 'src/app/shared/pipes/booking-item-name.pipe';

@Component({
  selector: 'send-quotation-dialog',
  templateUrl: './send-quotation-dialog.component.html',
  styleUrls: ['./send-quotation-dialog.component.css'],
  providers: [BookingService, BookingItemNamePipe],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    FlexModule,
    ReactiveFormsModule,
    NgIf,
    RouterLink,
    MatFormField,
    MatInput,
    CdkTextareaAutosize,
    MatCheckbox,
    MatError,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ]
})
export class SendQuotationDialogComponent implements OnDestroy {
  booking: Booking;
  formGroup: UntypedFormGroup = new UntypedFormGroup({
    note: new UntypedFormControl(''),
    deposit_amount: new UntypedFormControl(null, Validators.required)
  });

  priceMissing = false;
  requestDeposit = false;
  checked = false;
  saving = false;
  private ngUnsubscribe = new Subject<void>();
  stripeEnabled = false;

  constructor(
    public dialogRef: MatDialogRef<SendQuotationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private router: Router,
    private configService: ConfigService,
    private bookingService: BookingService
  ) {
    this.booking = data;
    if (!this.booking.deposit_amount) {
      this.formGroup.controls.deposit_amount.disable();
    } else {
      this.formGroup.controls.deposit_amount.enable();
      this.formGroup.controls.deposit_amount.patchValue(
        this.booking.deposit_amount
      );
      this.requestDeposit = true;
    }
    this.priceMissing =
      this.booking.items.filter((item) => {
        return !item.charge && !item.deleted_at;
      }).length > 0;

    this.configService.currentUser.subscribe((user) => {
      if (user.tenant) {
        this.stripeEnabled = user.tenant.hasStripeEnabled;
      }
    });
  }

  save() {
    this.saving = true;
    let formValue = this.formGroup.value;
    if (formValue.deposit_amount) {
      formValue.deposit_amount = currencyStringToNumber(
        formValue.deposit_amount
      );
    }
    this.bookingService
      .sendQuotation(this.booking, formValue)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  toggleDeposit(event: MatCheckboxChange) {
    this.requestDeposit = event.checked;
    if (this.requestDeposit) {
      this.formGroup.controls.deposit_amount.enable();
    }
  }
}
